<template lang="pug">
  .ajax-dropdown(v-on-away="away")
    .dropdown(:class="{ 'is-active': activeDropdown, 'selected': isSelected }")
      .dropdown-trigger
        button.button(@click="getData" :disabled="disabled")
          span {{ selectedItem.name || labelText }}
      .dropdown-menu(role="menu")
        .dropdown-content(v-if="items")
          a.dropdown-item(v-if="option" @click="selectItem({name:option, default: true})") {{ option }}
          a.dropdown-item(
            v-for="item in items"
            @click="selectItem(item.id || item)") {{ item[itemName] || item }}
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import { directive as onAway } from 'vue-clickaway'

const _ = require('lodash')

export default {
  name: 'AjaxDropdown',
  directives: {
    onAway
  },
  data () {
    return {
      activeDropdown: false,
      isSelected: false,
      selectedItem: {},
      items: [],
      received: false,
      isEdit: false,
      count: 0
    }
  },
  props: {
    action: {
      default: () => {
        return {
          method: '',
          params: {}
        }
      }
    },
    disabled: {
      default: false
    },
    labelText: {
      default: gettext('Please select')
    },
    itemName: {
      default: ''
    },
    returnItem: {
      default: ''
    },
    value: {
      default: () => {
        return []
      }
    },
    option: {
      default: ''
    },
    receive: {
      default: true
    }
  },
  methods: {
    getData () {
      this.activeDropdown = !this.activeDropdown
      if (this.action.method && this.activeDropdown) {
        if (this.receive) this.receiveData()
      }
    },
    receiveData () {
      return new Promise(resolve => {
        this.$store.dispatch(this.action.method, this.action.params).then(res => {
          this.count++
          this.items = res
          this.received = true
          resolve(res)
        })
      })
    },
    selectItem (item) {
      this.activeDropdown = false
      if (item.default) {
        this.selectedItem = item
        this.$emit('input', {})
      } else {
        this.selectedItem = _.find(this.items, {id: item}) || _.find(this.items, {name: item.name})
        if (this.returnItem.length) {
          this.$emit('input', this.selectedItem[this.returnItem])
        } else {
          this.$emit('input', this.selectedItem)
        }
      }
      this.$emit('selected')
      if (this.count > 1) this.$emit('updated')
      this.isSelected = true
    },
    away () {
      this.activeDropdown = false
    },
    setData (res) {
      let item = _.find(res, {'id': parseInt(this.value)}) || {}
      this.selectedItem = item
      this.isSelected = true
      if (this.returnItem.length) {
        this.$emit('input', item[this.returnItem])
      } else {
        this.$emit('input', item)
      }
      this.$emit('selected')
      if (this.count > 1) this.$emit('updated')
    },
    setDefault () {
      if (this.option) this.selectItem({name: this.option, default: true})
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    getLanguage: function () {
      if (this.action.method && this.receive) {
        this.receiveData().then(res => {
          this.selectedItem = _.find(res, {'id': this.selectedItem.id}) || {}
        })
      }
    },
    value: function (val) {
      if (Array.isArray(val)) {
        this.items = val
      } else if (typeof val === 'number') {
        if (!this.received && val !== -1) {
          this.isEdit = true
          this.$nextTick(function () {
            this.receiveData().then(res => {
              this.setData(res)
            })
          })
        } else {
          this.setDefault()
        }
      } else if (typeof val === 'string') {
        this.selectedItem = {}
        this.isSelected = false
      } else {
        return false
      }
    },
    items: function (val) {
      if (!val) {
        this.selectedItem = {}
        this.isSelected = false
      }
    },
    receive: function (val) {
      if (val) {
        this.receiveData().then(() => {
          if ((typeof this.value === 'number') || (typeof this.value === 'string')) this.selectItem(parseInt(this.value))
        })
      }
    }
  },
  mounted () {
    if (this.value && this.receive) {
      this.isEdit = true
      this.receiveData().then(res => {
        this.setData(res)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/billing/invoice/components/dropdown/index.vue